module.exports = __webpack_public_path__ + "media/images/favicons/favicon-friday-32x32-d06150db61f74c13674014b64b901ae0.png";